<template>
	<div id='topoWidget'>
		<div class="customer_header">
			<div></div>
			<div>拓扑展示</div>
			<div class="headerMenu_c" @click="isMenuShow"></div>
			<div class="dropDownMenu" v-show="menuShow">
				<div class="menuArrow"></div>
				<div class="menuPanel">
					<div class="menuListO" v-for="(topo,index) in topuList" @click="changeShowImg(topo,index)">
						<div class="topuImg menuListL"></div>
						<div class="menuListR" :class="{menuCur:index===selectedIndex}">{{topo.toponame}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="topuCont" id="topoContent">
			<!--<img :class="{menuTopuImgcur:index===selectedIndex}" :src="topu.topuImg" v-for="(topu,index) in topuList"/>-->
		</div>
	</div>
</template>

<script>
	var links = null;
	var nodes = null;

	var DataBox = twaver.DataBox;
	var ElementBox = twaver.ElementBox;
	var Data = twaver.Data;
	var Link = twaver.Link;
	var Node = twaver.Node;
	var Property = twaver.Property;



	var nodeList = []; //存储canvas中生成的节点
	var linkList = []; //存储canvas中生成的连线

	import { _api } from '@/service/interface'
	export default {
		name: 'WcTopu',
		data() {
			return {
				box:null,
				network:null,
				menuShow: false,
				selectedIndex: 0,
				topoData: null,
				topuList: [],
				isBigTopo:false,
				maxWidth:0
			}
		},
		methods: {
			init() {
				this.initTwaver();
				this.registerImages();
				window.onresize = function(e) {
					this.network.invalidate();
				};
				//page.getTopo();
			},
			initTwaver(){

				this.network = new twaver.vector.Network();
				this.box = this.network.getElementBox();
				this.network.getToolTip = function(element) {
					if(element && element instanceof twaver.Node) {
						return null;
					} else {
						return element.getToolTip();
					}
				};
				this.network.setMovableFunction(function(element){
					return false;
				})
				this.network.setRectSelectEnabled(false);

				//network.setToolTipEnabled(false)
			},

			resetTwaver(){
				this.network.setDragToPan(false);
				this.network.setWheelToZoom(false);
				/*if(this.isBigTopo){
					this.network.setZoomManager(new twaver.vector.PhysicalZoomManager(this.network));
				}*/
			},
			registerImages() {
				let names=["router","switch","ap","ac","security","unknown","cloud"];
				let status=["normal","warn"];
				names.forEach(name=>{
					status.forEach(statu=>{
						this.registerImage(`${name}_${statu}_64.png`,32,32);
					})
				})
			},
			//注册节点图标
			registerImage(src, width, height) {
				var imgurl=require("@/assets/images/topo/64/" + src)
				var img = new Image();
				img.src = imgurl;
				img.onload = ()=> {
					img.onload = null;
					twaver.Util.registerImage(this.getImageName(src), img, width, height);
					this.network.invalidateElementUIs();
				};
			},
			getImageName(url) {
				return url.split(".")[0];
			},
			isMenuShow() {
				this.menuShow = !this.menuShow;
			},
			changeShowImg(topo, index) {
				this.menuShow = !this.menuShow;
				this.selectedIndex = index;
				this.box.clear();
				if(document.getElementById("infoDiv")){
					document.getElementById("infoDiv").style.display='none'
				}
				this.network.getView().parentElement.remove();
				this.network =null;
				this.box=null;
				this.initTwaver();
				this.getTopoData(topo,true);
			},
			calculateHeight() {
				//首先获取页面的高度
				var bodyHei = document.documentElement.clientHeight;
				//tabbar的高度为
				var tabbarHei = 51;
				//设置内容区的高度
				var minePage = document.getElementById("topuPage");
				minePage.style.height = bodyHei - tabbarHei + "px";
			},
			getTopoList() {
				_api('_topo', '.code', {
					params: {
						mark: 'topoListNew'
					}
				}, res => {
					this.topuList = res.data;
					if(this.topuList.length > 0) {
						this.getTopoData(this.topuList[0])
					}
				}, err => {

				})
			},
			getTopoData(item,flag=false) {
				_api('_topo', '.code', {
					params: {
						mark: 'topoDataNew',
						topoId: item.topoId
					}
				}, res => {
					nodes=[];
					links=[];
					nodeList=[];
					this.topoData = res.data;
					links = res.data["links"];
					nodes = res.data["nodes"];
					let width=document.documentElement.clientWidth;
					let height=document.documentElement.clientHeight;
					let arr=nodes.map(item=>{
						return item["positionX"]
					})
					let maxWidth=Math.max(...arr);
					this.maxWidth=maxWidth;
					let scale=width/(maxWidth+32).toFixed(2)>=1?1:(width/(maxWidth+32).toFixed(2));
					if(scale<1){
						this.network.setZoom(scale)
						nodes.forEach(item=>{
							if(item["positionX"]*scale<52){
								item["positionX"]=52+item["positionX"]*scale
							}
							if(item["positionY"]*scale<52){
								item["positionY"]=52+item["positionY"]*scale
							}
							if((item["positionX"]*scale+52)>width){
								item["positionX"]-=52
							}
							if(item["positionY"]*scale>height){
								item["positionY"]-=152
							}
						})
						this.isBigTopo=true;
					}else{
						this.network.zoomReset(false);
						nodes.forEach(item=>{
							if(item["positionX"]<52){
								item["positionX"]+=32;
							}
							if(item["positionY"]<52){
								item["positionY"]+=32
							}
							if((item["positionX"]+52)>width){
								item["positionX"]-=52
							}
							if(item["positionY"]>height){
								item["positionY"]-=52
							}
						})
						this.isBigTopo=false;
					}
					this.resetTwaver();
					this.initTopo(this.topoData,flag);

				}, err => {

				})
			},
			initTopo(json,flag) {
				var networkPane = new twaver.controls.BorderPane(this.network);
				this.initNetwork(networkPane);
				this.initBox(json);
				this.addDeviceTip();
				networkPane=null;
			},
			//添加图元列表
			initNetwork(networkPane) {
				this.appendChild(networkPane.getView(), document.getElementById('topoContent'), 0, 0, 0, 0);
			},
			appendChild(e, parent, top, right, bottom, left) {
				e.style.position = 'absolute';
				if(left != null) {
					e.style.left = left + 'px';
				}
				if(top != null) {
					e.style.top = top + 'px';
				}
				if(right != null) {
					e.style.right = right + 'px';
				}
				if(bottom != null) {
					e.style.bottom = bottom + 'px';
				}
				parent.appendChild(e);
			},
			initBox(json) { //按照保存的位置生成拓扑图
				for(var i = 0; i < nodes.length; i++) {
					var nodeData = nodes[i];
					var name1;
					if(nodeData["ip"]) {
						name1 = nodeData["devName"] + '\r\n' + nodeData["ip"];
					} else {
						name1 = nodeData["devName"];
					}
					var key = nodeData["deviceId"];
					var unknownMac = "";
					var cloudMacs = "";
					var categories = nodeData["categories"];
					var unknowDeviceGroup = false;
					var img = "router_normal_64";
					if(nodeData.categories == 0) {
						img = "router_normal_64";
					} else if(nodeData.categories == 1) {
						img = "switch_normal_64";
					} else if(nodeData.categories == 2) {
						img = "ac_normal_64";
					} else if(nodeData.categories == 3) {
						img = "security_normal_64";
					}
					if(nodeData["deviceId"] == -1) {
						key = nodeData["unknownMac"];
						unknownMac = nodeData["unknownMac"];
						img = "unknown_normal_64";
					} else if(nodeData["deviceId"] == -2) {
						key = nodeData["cloudMacs"];
						cloudMacs = nodeData["cloudMacs"];
						img = "cloud_normal_64";
						unknowDeviceGroup = true;
					}
					var node = new twaver.Node({
						categories: categories,
						name: name1,
						devName: nodeData["devName"],
						ip: nodeData["ip"],
						nodeInfo: nodeData,
						deviceId: nodeData["deviceId"],
						unknownMac: unknownMac,
						cloudMacs: cloudMacs,
						unknowDeviceGroup: unknowDeviceGroup
					});
					node.setImage(img);
					this.box.add(node);
					nodeList[key] = node;
					nodeData=null;
					name1=null;
					key=null;
					unknownMac=null;
					cloudMacs=null;
					categories=null;
					img=null;
				}
				//循环把未加入的node加上
				for(var k = 0; k < links.length; k++) {
					this.createNodeByLinkData(links[k]);
				}
				//根据所有连线信息生成连线（包含原有的连线和新增的连线）
				for(var j = 0; j < links.length; j++) {
					this.createLinkByData(links[j]);
				}
				this.doLayout(this.box, "round");
			},
			//根据连线信息创建twaver的Node节点（注意，此方法只创建devId2<0的节点）
			createNodeByLinkData(link) {
				var n1 = link.devId1;
				var n2 = link.devId2;
				var linkData = link;
				try {
					//添加未知设备到nodeList
					if(n2 == -1) {
						var key = link.unknownMac;
						var nodeTemp = {};
						//isNew=true时表示从快照中读取，此时nodes中不论含与不含云，而nodeList中肯定不含云
						//isNew=false时表示从编辑拓扑表中获取，此时nodes中含云，nodeList中含云
						if(!nodeList[key]) {
							nodeTemp.customerId = customerId;
							nodeTemp.deviceId = -1;
							nodeTemp.devName = "未知" + key;
							nodeTemp.unknownMac = link.unknownMac;
							nodeTemp.positionX = 0;
							nodeTemp.positionY = 0;
							//nodeLink用来保存该设备连接的未知设备列表
							var node = new twaver.Node({
								categories: 0,
								name: "未知" + nodeTemp.unknownMac,
								devName: "未知" + nodeTemp.unknownMac,
								unknownMac: nodeTemp.unknownMac,
								ip: "",
								deviceId: nodeTemp.deviceId,
								nodeInfo: nodeTemp,
								nodeLink: []
							});
							node.setImage("unknown_normal_64");
							node.setClient('type', 'unknowDevice');
							node["_stat"] = true;
							this.box.add(node);
							nodeList[key] = node; //对于未知设备，使用unknownMac作为key值
						}
						var result = this.getNodeByDevId(nodes, key);
						if(!result) {
							nodes.push(nodeTemp);
						}
					}
					//添加云节点到 nodeList
					if(n2 == -2) {
						var cloudId = link.cloudId;
						var key = 'cloud' + cloudId;
						var nodeTemp = {};
						if(!nodeList[key]) {
							nodeTemp.customerId = customerId;
							nodeTemp.deviceId = -2; //代表云,从-2000开始
							nodeTemp.devName = "未知设备群" + cloudId;
							nodeTemp.ip = "";
							nodeTemp.unknownMac = "";
							nodeTemp.cloudMacs = key;
							nodeTemp.positionX = 0;
							nodeTemp.positionY = 0;
							nodeTemp.unknowDeviceGroup = true;
							var node = new twaver.Node({
								categories: 0,
								deviceId: nodeTemp.deviceId,
								name: "未知设备群" + cloudId,
								devName: "未知设备群" + cloudId,
								ip: "",
								unknownMac: nodeTemp.unknownMac,
								cloudMacs: nodeTemp.cloudMacs,
								unknowDeviceGroup: true,
								nodeInfo: nodeTemp,
								nodeLink: []
							});
							node.setImage("cloud_normal_64");
							this.box.add(node);
							nodeList[key] = node; //对于云，使用特殊的key=link.cloudMacs值
						}
						var result = this.getNodeByDevId(nodes, key);
						if(!result) {
							nodes.push(nodeTemp);
						}
					}
				} catch(e) {
					if(n2 == -1) {
						console.error("根据连线画节点：" + e.name + ":" + e.message + ",unknown_mac=" + linkData.unknownMac);
					} else if(n2 == -2) {
						console.error("根据连线画节点：" + e.name + ":" + e.message + ",cloud_mac=" + linkData.unknownMac);
					} else {
						console.error("根据连线画节点：" + e.name + ":" + e.message);
					}
				}
			},
			getNodeByDevId(nodes, key) {
				for(var i = 0; i < nodes.length; i++) {
					if(nodes[i].deviceId == key) {
						return nodes[i];
					}
					if(nodes[i].unknownMac == key) {
						return nodes[i];
					}
					if(nodes[i].cloudMacs == key) {
						return nodes[i];
					}
				}
				return null;
			},
			createLinkByData(linkData, isRecover) {
				var n1 = linkData["devId1"];
				var node1;
				if(n1 == -1) {
					node1 = nodeList[linkData.unknownMac];
					node1.setClient('type', 'unknowDevice');
				} else if(n1 == -2) {
					var key = 'cloud' + linkData.cloudId;
					node1 = nodeList[key];
					node1["_unknowDeviceGroup"] = true;
				} else if(n1 > 10000) {
					node1 = nodeList[n1];
				} else {
					node1 = nodeList[n1];
				}
				var n2 = linkData["devId2"];
				var node2;
				if(n2 == -1) {
					node2 = nodeList[linkData.unknownMac];
					node2.setClient('type', 'unknowDevice');
				} else if(n2 == -2) {
					var key = 'cloud' + linkData.cloudId;
					node2 = nodeList[key];
					node2["_unknowDeviceGroup"] = true;
				} else if(n2 > 10000) {
					node2 = nodeList[n2];
				} else {
					node2 = nodeList[n2];
				}
				//只要有一个不存在就不画这条链路
				if(!node1 || !node2) {
					return;
				}
				//设置节点的 _nodeLink属性
				if(!node1["_nodeLink"]) {
					node1["_nodeLink"] = new Array();
				}
				node1["_nodeLink"].push(node2);
				if(!node2["_nodeLink"]) {
					node2["_nodeLink"] = new Array();
				}
				node2["_nodeLink"].push(node1);
				this.createNormalLink(linkData, node1, node2, isRecover);
			},
			createNormalLink(linkData, from, to, isRecover) {
				var n1 = from["_deviceId"];
				if(n1 == -1) {
					n1 = to["_unknownMac"];
				} else if(n1 == -2) {
					n1 = to["_cloudMacs"];
				}
				var n2 = to["_deviceId"];
				if(n2 == -1) {
					n2 = to["_unknownMac"];
				} else if(n2 == -2) {
					n2 = to["_cloudMacs"];
				}
				if(linkData.type == 0) { //普通
					var fromData = this.getNodeByDevId(nodes, n1);
					var toData = this.getNodeByDevId(nodes, n2);
					var link = new twaver.Link(from, to);
					var ipTemp = "";
					if(toData["ip"] != "") {
						ipTemp = toData["ip"];
					}
					var intface2 = ipTemp + ":" + linkData["intfName2"];

					link.setToolTip("<b>" + fromData["ip"] + ":" + linkData["intfName1"] + "--" + intface2 + "</b>");
					if(toData["deviceId"] == -1) {
						link.setToolTip("<b>" + fromData["ip"] + ":" + linkData["intfName1"] + "--未知设备" + "</b>");
					}
					if(toData["deviceId"] == -2) {
						link.setToolTip("<b>" + fromData["ip"] + ":" + linkData["intfName1"] + "--未知设备群" + "</b>");
					}
					this.box.add(link);
					linkList[n1 + ":" + n2 + linkData.intfName1] = link;
					return link;
				} else if(linkData.type == 1) { //虚线
					var fromData = this.getNodeByDevId(nodes, n1);
					var toData = this.getNodeByDevId(nodes, n2);
					var link = new twaver.Link(from, to);
					var ipTemp = "";
					if(toData["ip"] != "") {
						ipTemp = toData["ip"];
					}
					var intface2 = ipTemp + ":" + linkData["intfName2"];
					link.setStyle("link.pattern", [10, 5]);
					link.setToolTip("<b>" + fromData["ip"] + ":" + linkData["intfName1"] + "--" + intface2 + "</b>");
					if(toData["deviceId"] == -1) {
						link.setToolTip("<b>" + fromData["ip"] + ":" + linkData["intfName1"] + "--未知设备" + "</b>");
					}
					if(toData["deviceId"] == -2) {
						link.setToolTip("<b>" + fromData["ip"] + ":" + linkData["intfName1"] + "--未知设备群" + "</b>");
					}
					//recoverColor(link,linkData);
					this.box.add(link);
					linkList[n1 + ":" + n2 + linkData.intfName1] = link;
					return link;
				} else if(linkData.type == 2 || linkData.type == 4) { //动态聚合口
					var array = linkData.dyStr.split(",");
					var linksNum = 0;
					var key11, key12, key21, key22;
					var linkCompare = {
						compare1: links
					};
					for(var key in linkCompare) {
						for(var i = 0; i < linkCompare[key].length; i++) {
							key11 = linkCompare[key][i]["devId1"];
							key12 = from["_deviceId"];
							key21 = linkCompare[key][i]["devId2"];
							key22 = to["_deviceId"];
							if(key21 == -1 || key22 == -1 || key21 == -2 || key22 == -2) {
								if(linkCompare[key][i]["devId2"] == -1) {
									key21 = linkCompare[key][i]["unknownMac"];
								}
								if(to["_deviceId"] == -1) {
									key22 = to["_unknownMac"];
								}
								if(linkCompare[key][i]["devId2"] == -2) {
									key21 = linkCompare[key][i]["cloudMacs"];
								}
								if(to["_deviceId"] == -2) {
									key22 = to["_cloudMacs"];
								}
							}
							if(key11 == key12 && key21 == key22 || key11 == key22 && key21 == key12) {
								linksNum++;
							}
						}
					}
					if(isRecover) {
						linksNum--;
					}
					var link = this.createDynamicLink(from, to, array, linkData["intfName1"], linkData["intfName2"], linksNum);
					//recoverColor(link,linkData);
					linkList[n1 + ":" + n2 + linkData.intfName1] = link;
					return link;
				} else if(linkData.type == 3 || linkData.type == 5) { //静态聚合口
					var type = linkData.type;
					var linksNum1 = 0;
					var key11, key12, key21, key22;
					var linkCompare = {
						compare1: links
					};
					for(var key in linkCompare) {
						for(var i = 0; i < linkCompare[key].length; i++) {
							key11 = linkCompare[key][i]["devId1"];
							key12 = from["_deviceId"];
							key21 = linkCompare[key][i]["devId2"];
							key22 = to["_deviceId"];
							if(key21 == -1 || key22 == -1 || key21 == -2 || key22 == -2) {
								if(linkCompare[key][i]["devId2"] == -1) {
									key21 = linkCompare[key][i]["unknownMac"];
								}
								if(to["_deviceId"] == -1) {
									key22 = to["_unknownMac"];
								}
								if(linkCompare[key][i]["devId2"] == -2) {
									key21 = linkCompare[key][i]["cloudMacs"];
								}
								if(to["_deviceId"] == -2) {
									key22 = to["_cloudMacs"];
								}
							}
							if(key11 == key12 && key21 == key22 || key11 == key22 && key21 == key12) {
								linksNum1++;
							}
						}
					}
					if(isRecover) {
						linksNum1--;
					}
					var link = this.createStaticLink(from, to, type, linkData.intfName1, linkData.intfName2, linkData.localStr1, linkData.localStr2, linksNum1, 1);
					//recoverColor(link,linkData);
					linkList[n1 + ":" + n2 + linkData.intfName1] = link;
					return link;
				}

			},
			//静态聚合口连线
			createStaticLink(from, to, type, intfName1, intfName2, interface1, interface2, index, bundleAmount) {
				var num = Math.floor(Math.random() * 1000);
				var link = new CLinkX(from, to);
				link.setStyle("link.color", "#aeaeae");
				link.setClient("icons.rx", 8);
				link.setClient("icons.ry", 7);
				link.setClient("icons.offset.percent", 1 / 3);
				link.setClient("link.bundle.index", 0.5 * (index - 1));
				link.setClient("link.bundle.length", bundleAmount);
				link.setClient("link.bundle.fromData", interface1);
				link.setClient("link.bundle.toData", interface2);
				link.setStyle("link.bundle.expanded", false);
				link.setStyle("link.bundle.id", num)
				//聚合口两端节点端口呈现
				var interface11 = new Array(),
					interface22 = new Array();
				interface11 = interface1.split(','), interface22 = interface2.split(',');
				var interface111 = "",
					interface222 = "";
				for(var i = 0; i < interface11.length; i++) {
					interface111 += interface11[i] + '<br/>';
				};
				for(var j = 0; j < interface22.length; j++) {
					interface222 += interface22[j] + '<br/>';
				};
				if(to["_deviceId"] == -1) {
					intfName2 = "";
					interface222 = "";
				} else if(to["_deviceId"] == -2) {
					intfName2 = "";
					interface222 = "";
				};
				link.setToolTip("<b>静态聚合<br/>" + from + ":" + intfName1 + "<br/>" + interface111 + "<br/>" + to + ":" + intfName2 + "<br/>" + interface222 + "</b>");
				this.box.add(link);
				return link;
			},
			//动态聚合口连线
			createDynamicLink(from, to, array, aggr1, aggr2, linksNum) {
				//初始化时显示定制链路，展开状态正常显示聚合口内容
				var link;
				var bundleAmount = array.length;
				var num = Math.floor(Math.random() * 1000);
				for(var i = 0; i < bundleAmount; i++) {
					var interfaces = array[i].split(":");
					link = new CLinkX(from, to);
					link.setStyle("link.color", "#aeaeae");
					link.setClient("icons.rx", 8);
					link.setClient("icons.ry", 7);
					link.setClient("icons.offset.percent", 1 / 3);
					link.setClient("link.bundle.index", i + 0.5 * (linksNum - 1));
					link.setClient("link.bundle.fromData", interfaces[0]);
					link.setClient("link.bundle.toData", interfaces[1]);
					link.setClient("link.bundle.aggr.fromData", aggr1);
					link.setClient("link.bundle.aggr.toData", aggr2);
					link.setClient("link.bundle.length", bundleAmount);
					link.setClient("link.bundle.linksNum", linksNum);
					link.setStyle("link.bundle.enable", true);
					link.setStyle("link.bundle.expanded", false);
					link.setStyle("link.bundle.id", num);
					link.setToolTip(
						"<b>动态聚合(共 " + bundleAmount + " 条)<br/>" + from + ":" + aggr1 + "--" + to + ":" + aggr2 + "</b>" + "<br/>" + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
						"<b>" + interfaces[0] + "--" + interfaces[1] + "</b>");
					this.box.add(link);
				}
				return link; //注意，此处return默认返回第一条link
			},
			doLayout(elementBox, type) {
				var autoLayouter = new twaver.layout.AutoLayouter(elementBox);
				autoLayouter.doLayout(type, function() {
					for(var a = 0; a < nodes.length; a++) {
						var haveHisTop = 0;
						var nodeX = 0;
						var nodeY = 0;
						var nodeIp = nodes[a].ip;
						var nodeUnknownMac = nodes[a].unknownMac;
						var nodeCloudMacs = nodes[a].cloudMacs;
						var key = nodes[a].deviceId;
						if(key == -1) {
							key = nodeUnknownMac;
						}
						if(key == -2) {
							key = nodeCloudMacs;
						}
						nodeX = nodes[a]["positionX"];
						nodeY = nodes[a]["positionY"];
						if(nodeX != 0 || nodeY != 0) {
							nodeList[key].setLocation(nodeX, nodeY);
						}
					}
				});
			},
			addDeviceTip() {
				//设备信息模态框
				var _infoDiv=null;

				if(document.querySelectorAll("#infoDiv").length==0){
					 _infoDiv = this.deviceInfo();
				}else{
					_infoDiv=document.getElementById("infoDiv")
				}
				this.network.addInteractionListener(function(e) {
					if(e.kind == 'clickElement' && e.element && e.element.getClassName() == 'twaver.Node' && e.element.getName()) {
						_infoDiv.style.display = "block";
						let deviceWidth=document.documentElement.clientWidth;
						let deviceHeight=document.documentElement.clientHeight;
						let x=e.event.changedTouches[0].pageX + 5;
						let y=e.event.changedTouches[0].pageY + 5;
						if(x+150<=deviceWidth){
							_infoDiv.style.left = x+ "px";
							_infoDiv.style.right ='auto';
						}else{
							_infoDiv.style.left ='auto'
							_infoDiv.style.right =(deviceWidth-x)+ "px";
						}

						if(y+80<=deviceHeight){
							_infoDiv.style.top =y + "px";
							_infoDiv.style.bottom ='auto'
						}else{
							_infoDiv.style.bottom =(deviceHeight-y) + "px";
							_infoDiv.style.top ='auto'
						}

						_infoDiv.style.color = "#000";
						_infoDiv.style.background = "#ffffe7";
						if(e.element["_nodeInfo"]) {
							if(e.element["_unknowDeviceGroup"]) {
                if(e.element["_nodeInfo"].devName!=null){
                  _infoDiv.innerHTML = "设备名称: " + e.element["_nodeInfo"].devName;
                }else{
                  _infoDiv.innerHTML = "设备名称: ";
                }
								if(e.element["_cloudMacs"]) {
									var str = e.element["_cloudMacs"];
									var str1 = str.split('-');
									var str2;
									if(str1.length > 2) {
										str2 = '<br/>' + '&nbsp;&nbsp;&nbsp;&nbsp;' + str1[0] +
											'<br/>' + '&nbsp;&nbsp;&nbsp;&nbsp;' + str1[1] + '...';
									} else if(str1.length == 2) {
										str2 = '<br/>' + '&nbsp;&nbsp;&nbsp;&nbsp;' + str1[0] +
											'<br/>' + '&nbsp;&nbsp;&nbsp;&nbsp;' + str1[1];
									} else if(str1.length == 1) {
										str2 = '<br/>' + '&nbsp;&nbsp;&nbsp;&nbsp;' + str1[0];
									}
									_infoDiv.innerHTML += "<br>mac地址列表: " + str2;
								} else {
									_infoDiv.innerHTML += "<br>mac地址列表: 无";
								}
							} else {
                if(e.element["_nodeInfo"].devName!=null){
                  _infoDiv.innerHTML = "设备名称: " + e.element["_nodeInfo"].devName;
                }else{
                  _infoDiv.innerHTML = "设备名称: ";
                }
								_infoDiv.innerHTML += "<br>IP地址: " + (e.element["_nodeInfo"].ip||"N/A");
								_infoDiv.innerHTML += "<br>设备版本: " + e.element["_nodeInfo"].version;
                if(e.element["_nodeInfo"].isIrf!=null){
                								if(e.element["_nodeInfo"].isIrf){
                									_infoDiv.innerHTML += "<br>是否堆叠: 是";
                								}else{
                									_infoDiv.innerHTML += "<br>是否堆叠: 否";
                								}
                							}else{
                								_infoDiv.innerHTML += "<br>是否堆叠: 否";
                							}
							}
						} else {
							_infoDiv.innerHTML = "暂无详细信息";
						}
					} else if(e.kind == 'clickElement' && e.element && e.element.getClassName() == 'twaver.Link' && e.element._toolTip){
						_infoDiv.style.display = "block";
						_infoDiv.style.position='absolute';
						let deviceWidth=document.documentElement.clientWidth;
						let deviceHeight=document.documentElement.clientHeight;
						let x=e.event.changedTouches[0].pageX + 5;
						let y=e.event.changedTouches[0].pageY + 5;
						if(x+150<=deviceWidth){
							_infoDiv.style.left = x+ "px";
							_infoDiv.style.right ='auto';
						}else{
							_infoDiv.style.left ='auto'
							_infoDiv.style.right =(deviceWidth-x)+ "px";
						}

						if(y+80<=deviceHeight){
							_infoDiv.style.top =y + "px";
							_infoDiv.style.bottom ='auto'
						}else{
							_infoDiv.style.bottom =(deviceHeight-y) + "px";
							_infoDiv.style.top ='auto'
						}
						_infoDiv.style.color = "#000";
						_infoDiv.style.background = "#ffffe7";
						_infoDiv.innerHTML =e.element._toolTip;

					}else{
						_infoDiv.style.display = "none";
					}
				});
			},
			//生成设备详细信息显示框
			deviceInfo() {
				var topoContent = document.getElementById("topoContent");
				var infoDiv = document.createElement("div");
				infoDiv.id = "infoDiv";
				topoContent.appendChild(infoDiv);
				infoDiv.style.display = "none";
				return infoDiv;
			},
		},
		mounted() {
			this.init();
			this.getTopoList();
			/*this.$nextTick(() => {
				this.initTopo()
			})*/
		}
	}
</script>

<style>
	.customer_header{
		background-image:linear-gradient(left,#00B5C0,#019BCD);
		background-image: -webkit-linear-gradient(left,#00B5C0,#019BCD);
	}
	#topoWidget {
		height: 100%;
	}

	.topuImg {
		width: 16px;
		height: 16px;
		background: url(../../assets/images/topuImg.png);
		background-size: 16px 16px;
	}

	.topuCont {
		width: 100%;
		padding-top: 50px;
		height: calc( 100% - 50px);
	}

	.topuCont>img {
		width: 100%;
		display: none;
	}

	.topuCont>img.menuTopuImgcur {
		display: block;
	}
	#infoDiv {
		position: absolute;
		font-size:15px;
		padding: 10px;
		background: #fff;
		box-shadow: 2px 2px 5px #000;
		z-index: 100;
		white-space: pre-line;
    	word-break: break-all;
    	margin: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/topu/WcTopu.vue